/* eslint-disable no-nested-ternary */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import { validateMaxLength } from '../../../../SharedModules/CommonUtilities/commonUtilities';
// custom function import
import {
  dispatchErrorMessages,
  dispatchSetHolidaysDetails,
} from '../store/actions';
import { HOLIDAY_DESC_REQ } from '../../../../SharedModules/Errors/constantMessageData';
import { autoFormateDate } from '../../../../SharedModules/utilities/utilities';
import { faL } from '@fortawesome/free-solid-svg-icons';

export default ({
  cellInfo,
  disabled,
  setDisabledSaveCancelBtn,
  onValueChanged,
  addAction = () => {},
  addSpecthera,
}) => {
  const dispatch = useDispatch();
  const colId = cellInfo?.column?.colId;
    const inputRef = useRef(null)
   const editingRef = useRef(false)
  const holidayData = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.holiday
  );
  const errorMessages = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.errorMessages
  );
  const mdspecthera = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.mdspecthera
  );
  const [value, setValue] = useState(cellInfo.value || '')
  let rowIndex =
    cellInfo.column.colId === 'holidayDescr' ? 0 : cellInfo?.rowIndex;
  if (
    holidayData &&
    holidayData.length > 0 &&
    cellInfo.column.colId === 'holidayDescr'
  ) {
    rowIndex = holidayData.findIndex((x) => {
      return x.id === cellInfo.data?.id;
    });
  }
  const setErrorMessages = (messages) => {
    dispatch(dispatchErrorMessages(messages));
  };
  const handleChange = (e) => {
    const inputValue = e.target?.value;
    editingRef.current = true
    setDisabledSaveCancelBtn(false);
    if(colId ==='holidayDescr'){
      setValue(inputValue)
    }
    if (colId === 'defTestAmt' || colId === 'defMailOrderMultiplier') {
      setValue(inputValue)
      if(inputValue === '' || inputValue === null || inputValue === undefined ){
        setValue('')
        return
      }
      if (!validateMaxLength(inputValue, 9, 2) && colId === 'defTestAmt') {
        return;
      }
      if (
        !validateMaxLength(inputValue, 11, 2) &&
        colId === 'defMailOrderMultiplier'
      ) {
        return;
      }

    }
    if (colId !== 'defTestAmt' && colId !== 'defMailOrderMultiplier'){
     cellInfo.node.setDataValue(colId, inputValue);
    }
    editingRef.current = false
  };


  useEffect(() => {
    if (editingRef.current) return;
    if (colId === 'defTestAmt' || colId === 'defMailOrderMultiplier') {
      if (
        cellInfo.value === null ||
        cellInfo.value === undefined ||
        cellInfo.value === ''
      ) {
        setValue('');
      } else {
        const n = Number(cellInfo.value);
        setValue(Number.isNaN(n) ? String(cellInfo.value) : n.toFixed(2));
      }
    } else {
      setValue(cellInfo.value || '');
    }
  }, [cellInfo.value, colId]);
  const handleOnBlur = useCallback(
    (e, name) => {
      editingRef.current = false;
      if (name === 'holidayDescr') {
        const newObj = [...holidayData];
        let localErr = errorMessages || [];
        if (e.target?.value?.trim()?.length > 0) {
          localErr = localErr?.filter((item) => {
            return !item.includes(`${HOLIDAY_DESC_REQ} ${rowIndex + 1}`);
          });
          newObj[rowIndex][name] = e.target?.value;
          newObj[rowIndex].holidayDesErr = false;
          if (!newObj[rowIndex].newRow) {
            newObj[rowIndex].updateRecord = true;
          }
        } else {
          newObj[rowIndex].holidayDesErr = true;
          if (!newObj[rowIndex].newRow) {
            newObj[rowIndex].updateRecord = true;
          }
          localErr.push(`${HOLIDAY_DESC_REQ} ${rowIndex + 1}.`);
        }
        cellInfo.node.setDataValue(colId, e.target?.value);
        dispatch(dispatchSetHolidaysDetails(newObj));
        setErrorMessages([...new Set(localErr)]);
      }
      if (
        name === 'startQtr' ||
        name === 'endQtr' ||
        name === 'rpcArInterfaceIdVO.nmFinStartQtr' ||
        name === 'nmAccountIdVO.startQtr'
      ) {
        cellInfo.node.setDataValue(
          colId,
          autoFormateDate(e.target?.value?.toUpperCase())
        );
      }
      if (name === 'defTestAmt' || name === 'defMailOrderMultiplier') {
        const val = e.target.value;
        let finalValue = ''
        if (val && val.toString().trim() !== '') {
          const numVal = parseFloat(val);
          if (!isNaN(numVal)) {
            finalValue = numVal.toFixed(2);
            setValue(finalValue);
          } else {
            finalValue = val;
          }
        } 
        if (typeof onValueChanged === 'function') {
          onValueChanged(colId, finalValue);
        } 
        cellInfo.node.setDataValue(colId, finalValue);
        return;
      } 
      if (typeof onValueChanged === 'function') {
        onValueChanged(colId, e.target.value);
      }
      cellInfo.node.setDataValue(colId, e.target.value);
    },
    [
      colId,
      onValueChanged,
      holidayData,
      rowIndex,
      errorMessages,
      dispatch,
      setDisabledSaveCancelBtn,
    ]
  );
  return (
    <div
      data-testid='system-param-text-box'
      className={`fullWidth  text-left td-active-cell ${
        cellInfo.required && (!cellInfo.value || !cellInfo.value.trim())
          ? 'tBill-validate'
          : ''
      }`}
    >
      {/* <label
        className="m-0 hide-elm"
        htmlFor={`systemParamtextFiled_${colId}_${rowIndex}`}
      >
        <span>label</span>{' '}
      </label> */}

      <TextField
        id={`systemParamtextFiled_${colId}_${rowIndex}`}
        fullWidth
        placeholder=''
        label={'Date'}
        InputLabelProps={{ shrink: true }}
        className={
          holidayData &&
          holidayData[rowIndex]?.holidayDesErr &&
          cellInfo.column.colId === 'holidayDescr'
            ? 'td-active-cell tBill-validate frr-display-hidden-label frr-remove-formClt-mt-label'
            : 'frr-display-hidden-label frr-remove-formClt-mt-label'
        }
        style={
          cellInfo.column.colId === 'holidayDescr' ? {} : { maxWidth: '400px' }
        }
        disabled={
          !!(
            (colId === 'defTestAmt' || colId === 'defMailOrderMultiplier') &&
            cellInfo?.data?.defTestOnInd === 0
          ) ||
          cellInfo?.data?.newRecord === false ||
          disabled
        }
        inputRef={inputRef}
        inputProps={{
          maxLength:
            colId === 'holidayDescr'
              ? 100
              : colId === 'endQtr'
              ? 6
              : colId === 'startQtr'
              ? 6
              : colId === 'rpcArInterfaceIdVO.nmFinStartQtr'
              ? 6
              : colId === 'specTheraClassCd'
              ? 10
              : colId === 'nmAccountIdVO.startQtr'
              ? 6
              : colId === 'nmAccountIdVO.fileType'
              ? 20
              : colId === 'nmAccountIdVO.accountNumber'
              ? 20
              : colId === 'rpcArInterfaceIdVO.nmFinBudgetRef'
              ? 20
              : colId === 'rpcArInterfaceIdVO.nmFinClass'
              ? 20
              : 50,
        }}
        value={value ?? ''}
     
        onChange={handleChange}
        onBlur={(e) => {
          handleOnBlur(e, colId);
        }}
        onKeyDown={(e) => {
        editingRef.current= true
        }}
      />
    </div>
  );
};
